export const resetPasswordConstants = Object.freeze({
  PASSWORD_RESET_SUCCESS_MESSAGE:
    'You may now return to the log in page and use your new password to access your account.',
  RETURN_TO_LOGIN: 'RETURN TO LOGIN',
})
